export const CreateNewCustomer = async (name, email, contact, userId) => {
    try {

        const response = await fetch(`${process.env.REACT_APP_BASE_URL}create-customer`, {
            method: "POST",
            headers: {
                "Content-Type": "application/json"
            },
            body: JSON.stringify({
                name,
                email: email,
                contact,
                userId
            })
        });

        if (!response.ok) {
            console.error(`Failed to create customer, status: ${response.status}`);
            return null;
        }

        // Attempt to parse JSON response
        const data = await response.json();

        return data?.customer?.id

    } catch (error) {
        console.error("Error creating customer:", error);
        return null;
    }
}